import React from 'react';

import './assest/index.scss';

const Loader = () => {
	return (
		<span className="loader" />
	)
}

export default Loader;